import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  Edit,
  SimpleForm,
  TextInput,
  Create,
} from 'react-admin';

const BlogTitle = ({ record }) => {
    return <span>{record ? `"${record.title}"` : ''}</span>;
};

export const BlogList = props => (
  <List {...props} sort={{ field: 'created_at', order: 'DESC' }}>
      <Datagrid rowClick="edit">
          <TextField source="title" />
          <TextField source="created_at" />
          <TextField source="content" />
      </Datagrid>
  </List>
);

export const BlogEdit = props => (
  <Edit title={<BlogTitle/>} {...props}>
      <SimpleForm>
          <TextInput source="title" />
          <TextInput multiline source="content" />
      </SimpleForm>
  </Edit>
);

export const BlogCreate = props => (
  <Create title={<BlogTitle/>} {...props}>
      <SimpleForm>
          <TextInput source="title" />
          <TextInput multiline source="content" />
      </SimpleForm>
  </Create>
);
